export default __webpack_public_path__ + "static/082-b19ccddb3efbd7dfd18380dbbb32f680.jpg";